// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_b9c7ce', '__Inter_Fallback_b9c7ce'","fontStyle":"normal"},"className":"__className_b9c7ce"};